import { FileInput as BaseFileInput } from '@/components/atoms/FileInput';
import { withForm } from '@/core/form/withForm';

export const FileInput = withForm(BaseFileInput);
